import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {InfoCircleIcon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {projectEndingReasonToLabel} from '../../utils'

export const ProjectDetailsHeaderEarlyClosingMotivation = ({project}: {project: ProjectExtended}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()
    if (!project.conclusionReason) {
        return null
    }

    return (
        <Tooltip variant="light" content={t(projectEndingReasonToLabel[project.conclusionReason])}>
            <Flexbox gap={1} align="center">
                <InfoCircleIcon size={16} color={palette.neutral[950]} />
                <Text size="textSm" weight="500" palette="neutral" shade="950" style={{textDecoration: 'underline'}}>
                    {t('projects:patient_decision')}
                </Text>
            </Flexbox>
        </Tooltip>
    )
}
